export const appName = "webApp";

export function getRequest(url) {
  return fetch(url).then((resp) => resp.json());
}

export function postRequest(url, params) {
  return fetch(url, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(params),
  }).then((resp) => resp.json());
}



// WEBPACK FOOTER //
// ./src/common/utilities/apimanager.helper.js